import { useState } from 'react';

export default function PlayStoreButton({ href = "https://play.google.com/store/apps/details?id=com.metaqode.turfx", style = {} }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '12px',
        backgroundColor: '#000000',
        backgroundImage: 'linear-gradient(180deg, #161616 0%, #000000 100%)',
        color: '#FFFFFF',
        padding: '9px 20px',
        borderRadius: '12px',
        textDecoration: 'none',
        border: isHovered ? '1.5px solid rgba(255, 255, 255, 0.45)' : '1.5px solid rgba(255, 255, 255, 0.2)',
        boxShadow: isHovered 
          ? '0 10px 28px rgba(0, 0, 0, 0.6), 0 0 20px rgba(52, 168, 83, 0.25)' 
          : '0 6px 20px rgba(0, 0, 0, 0.4)',
        transform: isHovered ? 'translateY(-2px) scale(1.02)' : 'translateY(0) scale(1)',
        transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
        cursor: 'pointer',
        userSelect: 'none',
        maxWidth: 'fit-content',
        ...style
      }}
    >
      {/* Official Google Play SVG Icon */}
      <svg 
        width="26" 
        height="26" 
        viewBox="0 0 512 512" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        style={{ flexShrink: 0 }}
      >
        <path d="M48.7 13.6C44.7 17.8 42.5 24.2 42.5 32.5V479.5C42.5 487.8 44.7 494.2 48.7 498.4L51.3 500.8L312.4 239.7V236.3L51.3 25.2L48.7 13.6Z" fill="url(#play_a)"/>
        <path d="M399.4 326.7L312.4 239.7V236.3L399.5 149.3L401.3 150.3L504.4 208.9C513.8 214.2 513.8 221.8 504.4 227.1L401.3 285.7L399.4 326.7Z" fill="url(#play_b)"/>
        <path d="M401.3 285.7L312.4 239.7L48.7 500.8C54.8 507.2 64.9 508.1 76.5 501.5L401.3 285.7Z" fill="url(#play_c)"/>
        <path d="M401.3 150.3L76.5 24.5C64.9 17.9 54.8 18.8 48.7 25.2L312.4 286.3L401.3 150.3Z" fill="url(#play_d)"/>
        <defs>
          <linearGradient id="play_a" x1="294.6" y1="469" x2="33.7" y2="208.1" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#00A0FF"/>
            <stop offset="0.01" stopColor="#00A1FF"/>
            <stop offset="0.26" stopColor="#00BEFF"/>
            <stop offset="0.51" stopColor="#00D4FF"/>
            <stop offset="0.76" stopColor="#00E3FF"/>
            <stop offset="1" stopColor="#00E8FF"/>
          </linearGradient>
          <linearGradient id="play_b" x1="520" y1="238" x2="307" y2="238" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#FFE000"/>
            <stop offset="0.4" stopColor="#FFBD00"/>
            <stop offset="0.77" stopColor="#FFA500"/>
            <stop offset="1" stopColor="#FF9C00"/>
          </linearGradient>
          <linearGradient id="play_c" x1="424.3" y1="272.7" x2="167.3" y2="529.7" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#FF3A44"/>
            <stop offset="1" stopColor="#C31162"/>
          </linearGradient>
          <linearGradient id="play_d" x1="167.3" y1="-53.7" x2="424.3" y2="203.3" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#32A071"/>
            <stop offset="0.07" stopColor="#2DA771"/>
            <stop offset="0.48" stopColor="#15CF74"/>
            <stop offset="1" stopColor="#06E775"/>
          </linearGradient>
        </defs>
      </svg>

      {/* Button Text */}
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left', lineHeight: 1 }}>
        <span style={{ 
          fontSize: '0.62rem', 
          fontWeight: '700', 
          letterSpacing: '0.8px', 
          textTransform: 'uppercase', 
          color: '#9CA3AF',
          marginBottom: '3px'
        }}>
          GET IT ON
        </span>
        <span style={{ 
          fontSize: '1.05rem', 
          fontWeight: '700', 
          letterSpacing: '0.2px', 
          color: '#FFFFFF',
          fontFamily: "'Sora', -apple-system, Roboto, sans-serif"
        }}>
          Google Play
        </span>
      </div>
    </a>
  );
}
